module.exports = __webpack_public_path__ + "img/content-1.84cd91aa.png";